import aiDraftShared from '@/locales/en-CA/aiDraftShared.js';

export default {
    attachmentPreview: 'Preview',
    archive: 'Archive conversation',
    archived: 'Archived',
    conversationDetails: 'Conversation details',
    restoreConversation: 'Restore Conversation',
    notifications: {
        smsNotLoading: 'Error loading SMS.',
        parseTemplateFailed: 'Failed to parse template.',
        noMobileNumber: "{lead} doesn't have any mobile phone number.",
        smsProviderUnavailable:
            'No SMS number is configured for this account. Please contact Support to add one.',
        searchingExistingConversation:
            'An error occurred while searching for an existing conversation with {lead}.',
        archiveFailed: 'Failed to archive conversation.',
        unarchiveFailed: 'Failed to restore conversation.',
        conversationArchivedSuccess: 'Conversation archived successfully.',
        conversationUnarchivedSuccess: 'Conversation restored successfully.',
        smsSendFailed: 'Failed to send SMS.',
        attachmentSendFailed: 'Failed to send attachment.',
        unsupportedFileType:
            '{name}: unsupported file type. Only GIF, JPEG, PNG and PDF files are allowed.',
        noOutgoingProvider: 'No outgoing phone provider configured for SMS.',
        providerPhoneNotConfigured: 'SMS provider phone number is not configured.',
        phoneNotFound: 'The selected phone number was not found on this lead.',
        conversationLoadFailed: 'Failed to load conversation. Please try again.',
    },
    errors: {
        no_sms_provider_available: 'All dealer numbers are already used for this customer phone.',
        lead_unsubscribed: 'This lead has unsubscribed from SMS communications.',
        casl_expired: 'Cannot send SMS: customer consent has expired.',
        sms_communication_disabled: 'SMS communication is not available for this lead.',
        unableToLoadConversation: 'Unable to load conversation. Please try again later.',
    },
    readOnlyConversation: 'This conversation is read-only.',
    smsProviderInactive:
        'This dealer phone number is inactive and can no longer send new messages.',
    sendUnavailable: 'SMS sending is unavailable for this conversation.',
    filter: {
        active: 'Active',
        all: 'All Conversations',
        archived: 'Archived',
        title: 'Display Conversations',
        intelligentFilter: 'Intelligent Filter',
        intelligentFilterTooltip:
            'When active, conversations containing only appointment confirmations, campaign messages or keywords "YES", "NO" and "STOP" won\'t be shown',
    },
    group: 'GROUP',
    hasMultiplePhones: 'has multiple mobile numbers. Choose one to start the conversation.',
    historicalPhoneMismatch:
        'The phone number used for this activity no longer matches the current customer data. It cannot be selected.',
    selectCurrentPhone: 'Select a current mobile number for {lead} to continue.',
    attachments: 'Attachments',
    documents: 'Documents',
    images: 'Images',
    messages: 'Messages',
    newConversation: 'New Conversation',
    peopleInChat: 'People in chat',
    redirectToLead: 'Redirect to lead',
    removeAttachment: 'Remove',
    searchEmojis: 'Search emojis',
    searchPlaceholder: 'Search customer or phone number',
    selectPhone: 'Select a phone number',
    sentFromDealerPhone: 'Sent from Dealer Phone: {phone}',
    smsInputPlaceholder: 'Type a message',
    template: {
        category: 'Category',
        insert: 'Insert',
        insertEn: 'Insert (EN)',
        insertFr: 'Insert (FR)',
        noResults: 'No templates found.',
        searchPlaceholder: 'Search message...',
        selectCategory: 'Select Category',
        table: {
            name: 'Name',
            category: 'Category',
            message_en: 'Message (EN)',
            message_fr: 'Message (FR)',
        },
        title: 'Insert Template',
    },

    pagination: {
        paused: 'Loading paused. You can load more results.',
        loadMore: 'Load more',
    },
    conversationsList: {
        failedToLoad: 'Failed to load conversations.',
        noResults: 'No results',
        timestamp: {
            justNow: 'Just now',
            minsAgo: '{count} min ago | {count} mins ago',
            hoursAgo: '{count} hour ago | {count} hours ago',
        },
    },
    messagesList: {
        failedToLoad: 'Failed to load messages.',
        failedToDownloadAttachment: 'Failed to download attachment.',
        unreadSeparator: 'Unread messages',
        newMessages: '{count} new message | {count} new messages',
    },
    message: {
        notDelivered: 'Not delivered',
        notDeliveredWithRetry: 'Not delivered. Click to retry.',
        notDeliveredNoAccess: 'Not authorized',
        notDeliveredUnreachable: 'This number is a landline or unreachable',
        notDeliveredUnreachableWithRetry: 'This number could not be reached. Click to retry.',
        error: 'An error occurred. Click to retry.',
        errorNoAccess: 'You do not have access to write to this contact.',
        retryFailed: 'Failed to retry sending the message. Please try again.',
    },
    dateSeparator: {
        today: 'Today',
        yesterday: 'Yesterday',
    },
    appointment: {
        confirmed: 'Appointment confirmed',
        canceled: 'Appointment canceled',
        pending: 'Awaiting confirmation',
    },
    consentExpired: 'Customer Consent Expired',
    consentExpiredMessage:
        "Without the explicit customer's consent, Canada's anti-spam law prevents you from communicating electronically with this lead.",
    customerUnsubscribed: 'Customer Unsubscribed',
    unsubscribedMessage:
        'The contact must resubscribe to SMS communications to allow you to message them.\nTo do so, they simply need to text "UNSTOP" to {phoneNumber}',
    aiDraft: {
        ...aiDraftShared,
        rateLimit: 'AI usage limit reached. Please wait {emphasis}',
        rateLimitEmphasis: '{seconds} seconds before trying again.',
        smsTextLimitReached: '{limit} character limit reached.',
        undo: 'Undo',
        updateInstructionLabel: 'Describe your changes',
        updateInstructionLimitReached: '255 character limit reached.',
        updateInstructionPlaceholder: 'Describe your changes',
        updateServiceLeadUnavailable: 'Update with AI is only available for sales leads.',
        updateWithAi: 'Update with AI',
    },
};
